<template>
  <div id="app">
    <router-view/>
    <Announcement v-if="show" @close="show=false" @NEXT="index=index+1" :mode="announcements[index].mode" :image="announcements[index].image"
    :show="announcements[index].actived" :label="announcements[index].name" :content="announcements[index].content" :last="index===(announcements.length-1)"
     class="announcement" width="500px" height="500px"/>
    <div hidden>
      <audio controls id="orders" hidden>
        <source :src="`${pathname}/audio/orders.mp3`" type="audio/mpeg">
          Your browser does not support the audio element.
      </audio>
      <audio controls id="alarm" hidden>
        <source :src="`${origin}${pathname}/audio/alarm.mp3`" type="audio/mpeg">
          Your browser does not support the audio element.
      </audio>
    </div>
  </div>
</template>

<script>
import { getcusapi } from './store/fetch'
import Announcement from './components/announcement.vue'
export default {
  components: {
    Announcement
  },
  data () {
    return {
      origin: window.location.origin,
      pathname: window.location.pathname,
      show: false,
      announcements: [],
      index: 0
    }
  },
  async beforeMount () {
    // document.body.style.transform = `scale(${window.visualViewport.width / 1920})`
    // window.onresize = () => {
    //   console.log('[window][resize]', window.visualViewport, window.screen)
    //   document.body.style.transform = `scale(${window.visualViewport.width / 1920})`
    // }
  },
  async mounted () {
    // const lists = localStorage.getItem('read')
    const announcements = await getcusapi('announcement/announcement/staff')
    this.announcements = announcements
    // this.announcements = lists ? announcements.filter(e => !JSON.parse(lists).includes(e._id)) : announcements
    if (announcements.length > 0) {
      this.show = true
      this.index = 0
    }
  }

}
</script>
<style lang="scss">
@viewport {
  width: device-width;
  zoom: 1;
  min-zoom: 0.1;
  max-zoom: 5;
  user-zoom: zoom;
}
.search { border: none; }
:root {
  --dialogPosition:absolute;
  --backdrop: rgba(165, 165, 165, 0.2);
  --point: #F0B214;
  --highlight: #FF8B8B;
  --訂金: #F0B214;
  --旅行社: #517FA4;
  --遊覽車: #E9AE67;
  --活動公司: #68A89C;
  --公司企業: #F1856E;
  --個體戶: #CCA16E;
  --其他: #75A9B9;
  --color-printbotder: #5E5E5E;
  --color-phone-title: #A06A28;
  --折讓: #77AFC0;
  --開立: #CC9B6D;
  --作廢: #FF8B8B;
  --已出貨: #85CA9E;
  --預約中: #517FA4;
  --通知付訂: #FF8B8B;
  --已付訂: #FCAE28;
  --已退款: #999999;
  --已付款: #7FA451;
  --已報到: #CCA16E;
  --待確認: #F0B214;
  --已聯繫: #94B1B6;
  --已發簡訊: #B3ADF3;
  --新訂單: #517FA4;
  --待出貨: #85CA9E;
  --問題單: #A569FF;
  --已確認: #85CA9E;
  --已完成: #CCA16E;
  --已取消: #8C8C8C;
  --color-tab: #7FA451;
  --門票: #E9AE67;
  --抵用券: #94B1B6;
  --商品兌換: #7FA7DA;
  --餐廳兌換: #CFA590;
  --活動票券: #EE9999;
  --預約排程: #AAAAAA;
  --排程預約: #AAAAAA;
  // --color-pri: #CC9B6D;

  // --color-checked: #EFAE7E;
  // --color-pri: #CC9B6D;
  // --color-bar: #FFF4E2;
  // --color-infobox: #FFF4E2;

  // --color-checked: #517fa4;
  // --color-pri: #40526c;
  // --color-bar: #e9f5fc;
  // --color-infobox: #e9f5fc;
  --color-pri: #AB7F56;
  --color-checked: #c8a77f;
  --color-infobox: #FFFAE7;
  --color-bar: #FFFAE7;

  --color-letter: #5E5E5E;
  --color-confirm: #E37878;
  --color-saveAs: #CCA16E;
  --color-cancel: #B8B8B8;
  --color-pri-letter: #FFFFFF;
  --color-fn9: #CACACA;
  --color-cube-1: #3B4A54;
  --color-cube-2: #49676E;
  --color-cube-3: #706863;
  --color-cube-4: #7A3911;
  --color-cube-5: #334257;
  --color-cube-6: #476072;
  --color-cube-7: #548CA8;
  --color-home-0: #68A89C;
  --color-home-1: #517FA4;
  --color-home-2: #8F5E32;
  --color-home-3: #BD4B4B;
  --color-home-4: #6C89B5;
  --color-home-5: #476072;
  --color-home-6: #6D6D6D;
  --color-home-7: #9EAF89;
  --color-home-8: #745C8C;
  --color-rest: #C78550;
  --color-現場: #334257;
  --color-暫停: #5E5E5E80;
  --color-預約-0: #CCA16E;
  --color-預約-1: #C78550;
  --color-預約-2: #E37878;
  --color-完成: #7FA451;
  --color-selected: var(--color-bar);
  --color-signupPage: #778566;
  --color-loginpage: #778566;
  --color-number: #E37878;
  --color-number-2: #517FA4;
  --color-border: #CACACA;
  --內用: #FF7373;
  --外帶: #9EAF89;
  --宅配: #A3C777;
  --自取: #7FA7DA;
  --現場: #a884cd;
  --線上: #7FA7DA;
  --btn-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
}
*{
  font-family: 'Noto Sans TC';
}
.toolong {
  white-space:nowrap;
  overflow:hidden;
  text-overflow: ellipsis;
  text-align: start;
}
.toolong2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: inherit;
}
th {
  font-family: 'Noto Sans TC';
}
a {
  font-family: 'Noto Sans TC';
}
*, *::before, *::after {
  box-sizing: border-box;
}
table>tbody>tr:hover {
  background-color: var(--color-bar);
}
// @mixin element-color($color) {
//   background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.51329 3.88657H11.6013C12.0217 3.88657 12.3624 3.50747 12.3624 3.04C12.3624 2.57223 12.0217 2.19312 11.6013 2.19312H8.51329C8.09315 2.19312 7.75242 2.57223 7.75242 3.04C7.75242 3.50747 8.09315 3.88657 8.51329 3.88657ZM16.6443 2.19312H15.3372C14.9168 2.19312 14.576 2.57223 14.576 3.04C14.576 3.50747 14.9168 3.88657 15.3372 3.88657H16.6443C17.6541 3.88687 18.4732 4.79643 18.4753 5.92003V6.48331H1.52494V5.92003C1.52709 4.79643 2.34617 3.88687 3.356 3.88657H4.7012C5.12133 3.88657 5.46206 3.50747 5.46206 3.04C5.46206 2.57223 5.12133 2.19312 4.7012 2.19312H3.356C1.50509 2.19372 0.00375602 3.8606 0 5.92003V16.0213C0.00375602 18.0804 1.50509 19.7476 3.35574 19.7482H16.644C18.4946 19.7479 19.996 18.0807 20 16.0213V5.92003C19.9962 3.8606 18.4949 2.19342 16.6443 2.19312ZM16.6443 18.0548H3.356C2.34617 18.0545 1.52709 17.1449 1.52494 16.0213V8.17676H18.4753V16.0213C18.4732 17.1449 17.6541 18.0545 16.6443 18.0548ZM6.56901 5.25554C6.98969 5.25584 7.33095 4.87703 7.33148 4.40897V1.2761C7.33148 0.807439 6.99022 0.427734 6.56901 0.427734C6.1478 0.427734 5.80654 0.807439 5.80654 1.2761V4.40897C5.80708 4.87673 6.14834 5.25584 6.56901 5.25554ZM13.4881 5.25554C13.6902 5.25584 13.8841 5.16658 14.0271 5.00778C14.1701 4.84897 14.2506 4.63345 14.2506 4.40867V1.2761C14.2506 0.807439 13.9093 0.427734 13.4881 0.427734C13.0669 0.427734 12.7257 0.807439 12.7257 1.2761V4.40897C12.7262 4.87673 13.0675 5.25584 13.4881 5.25554ZM5.81942 10.321H3.5701C3.14996 10.321 2.80923 10.7001 2.80923 11.1678C2.80923 11.6353 3.14996 12.0144 3.5701 12.0144H5.81942C6.23982 12.0144 6.58055 11.6353 6.58055 11.1678C6.58028 10.7001 6.23955 10.321 5.81942 10.321ZM11.0803 10.321H8.83121C8.4108 10.321 8.07008 10.7001 8.07008 11.1678C8.07008 11.6353 8.4108 12.0144 8.83121 12.0144H11.0803C11.5004 12.0144 11.8411 11.6353 11.8411 11.1678C11.8411 10.7001 11.5004 10.321 11.0803 10.321ZM16.3411 10.321H14.0918C13.6716 10.321 13.3309 10.7001 13.3309 11.1678C13.3309 11.6353 13.6716 12.0144 14.0918 12.0144H16.3406C16.761 12.0144 17.1017 11.6353 17.1017 11.1678C17.1017 10.7001 16.761 10.321 16.3406 10.321H16.3411ZM5.81942 13.8777H3.5701C3.29591 13.8741 3.04157 14.0347 2.9034 14.298C2.7655 14.5616 2.7655 14.8873 2.9034 15.1506C3.0413 15.4141 3.29591 15.5747 3.5701 15.5709H5.81942C6.09334 15.5744 6.34821 15.4141 6.48611 15.1506C6.62401 14.887 6.62401 14.5616 6.48611 14.298C6.34794 14.0344 6.09334 13.8741 5.81942 13.8777ZM11.0803 13.8777H8.83121C8.55729 13.8741 8.30241 14.0347 8.16451 14.298C8.02662 14.5616 8.02662 14.8873 8.16451 15.1506C8.30268 15.4141 8.55729 15.5747 8.83121 15.5709H11.0803C11.3542 15.5744 11.6088 15.4141 11.747 15.1506C11.8849 14.887 11.8849 14.5616 11.747 14.298C11.6088 14.0344 11.3542 13.8741 11.0803 13.8777ZM16.3411 13.8777H14.0918C13.8176 13.8741 13.5633 14.0347 13.4251 14.298C13.2872 14.5616 13.2872 14.8873 13.4251 15.1506C13.563 15.4141 13.8176 15.5747 14.0918 15.5709H16.3406C16.6148 15.5744 16.8694 15.4141 17.0073 15.1506C17.1452 14.887 17.1452 14.5616 17.0073 14.298C16.8694 14.0347 16.6148 13.8741 16.3406 13.8777H16.3411Z" fill="#{$color}"/></svg>');
// }
select option {
  appearance: none;
}
select option:target {
  background-color: var(--color-infobox);
}
.closedialog {
  background-color: #FFFFFF;
  mask-image: url(/close.svg);
  border: none;
  outline: none;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}
button {
  border: none;
}
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  background-color: var(--color-border);
}

@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100;300;400;500;700;900&family=Roboto:wght@100;300;400;500;700;900&display=swap');
input, select, textarea, button {
  font-family: "Noto Sans TC", Roboto, Arial;
}
#page {
  min-width: 1850px;
  min-height: 969px;
}
#app {
  width: 100vw;
  height: 100vh;
}
#appLogin {
  min-width: 1920px;
  min-height: 969px;
}
#appLogin {
  font-family: "Noto Sans TC", Roboto, Arial;
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 70px calc(100vw - 70px);
  overflow: hidden;
  max-width: 1920px;
  background-color: #FFFFFF;
  position: relative;
}
button, input, select, textarea {
  outline: none;
}
div, label {
  user-select: none;
}
td {
  user-select: text;
}
input[type=text]::placeholder {
  color: #CACACA;
}
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #F5F5F5;
}
::-webkit-scrollbar-thumb {
  border-radius: 20px;
  box-shadow: inset 0 0 6px #0000004d;
  background-color: var(--color-pri);
}
::-webkit-scrollbar-track {
  border: none;
  border-radius: 20px;
  background-color: #d8d8d8;
  border: 2px solid #FFFFFF!important;
}

@media print {
  *{box-shadow:none;}
}
</style>
